// extracted by mini-css-extract-plugin
module.exports = {"wrap":"MobileGamInlineAd_wrap__zaYOn","header":"MobileGamInlineAd_header__dcKO1","label":"MobileGamInlineAd_label__BOG6f","footerSpacer":"MobileGamInlineAd_footerSpacer__1LVJH"};